import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PDFAnnotatorMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "PDF Annotator Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_annotator", title: "Annotate PDF Files For Free" },
    data2: {
      link: "/pdf_annotator",
      title: "Edit, Comment, Annotate PDF Free",
    },
    data3: { link: "/pdf_annotator", title: "Highlight PDF, PDF Annotator" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Annotate PDF online easily. Add comments, highlights, drawings, and notes to PDFs quickly with our fast and secure PDF annotator tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf annotator, annotate pdf, pdf annotation tool, add comments to pdf, highlight pdf, draw on pdf, pdf editor online, online pdf annotator, add notes to pdf, pdf markup tool, pdf highlighter, annotate pdf online, pdf annotation software, pdf commenting tool, pdf review tool"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <></>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1615002918}`}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF annotator offline website is a powerful and secure tool designed to let users add comments, highlights, notes, and drawings to PDF documents directly on their device, without the need for an internet connection. This advanced offline PDF annotation tool allows students, professionals, and businesses to review, edit, and collaborate on PDFs efficiently while keeping sensitive documents private. With features such as text highlighting, underlining, striking through, sticky notes, freehand drawing, and shape annotations, this PDF annotator offline ensures that your feedback and edits are precise, organized, and professional. Whether you are annotating academic assignments, business reports, contracts, or research papers, our offline PDF annotation software preserves all changes securely and works seamlessly without uploading files to the cloud. The platform is compatible with Windows, macOS, and other devices, allowing users to annotate PDFs anytime, anywhere. By providing fast, reliable, and offline PDF editing capabilities, this offline PDF annotator enhances productivity, simplifies document collaboration, and ensures your data remains fully private. If you’re looking for a safe, high performance, and feature rich PDF annotator offline tool, this website is the perfect solution for all your PDF reviewing and annotation needs." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Upload",
              step3: "Annotate",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Annotator"
            why_use={[
              {
                title: "Add Comments and Notes Easily",
                description:
                  "This PDF annotator tool allows users to insert comments, notes, and explanations directly into PDF documents, making it easier to review and provide feedback.",
              },

              {
                title: "Highlight Important Text",
                description:
                  "With a PDF annotation tool online or offline, you can highlight key points in reports, contracts, or research papers for quick reference and clarity.",
              },

              {
                title: "Underline and Strike Through Text",
                description:
                  "Our PDF annotator lets you underline or strike through text, helping to mark important information or indicate corrections efficiently.",
              },

              {
                title: "Draw and Mark Shapes",
                description:
                  "Advanced PDF annotation tools allow freehand drawing, shapes, and arrows, enabling visual annotations that make documents more interactive and clear.",
              },

              {
                title: "Improve Collaboration and Feedback",
                description:
                  "Using a PDF annotator online or offline helps teams, students, and professionals review documents collaboratively, leaving precise feedback directly in the PDF.",
              },

              {
                title: "Preserve Original Document Layout",
                description:
                  "This reliable PDF annotation tool maintains the original formatting, fonts, and layout of your PDF while allowing edits and annotations.",
              },

              {
                title: "Works Offline for Data Privacy",
                description:
                  "Our offline PDF annotator allows you to annotate documents without uploading them online, keeping sensitive data secure and private.",
              },

              {
                title: "Enhance Productivity and Efficiency",
                description:
                  "Our PDF annotator tool saves time by enabling quick edits, comments, and highlights without converting files to other formats.",
              },

              {
                title: "Ideal for Academic and Business Use",
                description:
                  "Whether marking lecture notes, reviewing research papers, editing contracts, or auditing reports, a PDF annotator is essential for students, teachers, and professionals.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I annotate a PDF online for free?",
                description:
                  "You can annotate a PDF using a PDF annotation tool. Open your document, select the available tools for highlighting, drawing, adding text, or making notes, and save or download the annotated PDF."
              },
              {
                title: "What is a PDF annotator?",
                description:
                  "A PDF annotator is a tool that lets you add notes, highlights, drawings, comments, and other markings to a PDF document. It is useful for studying, reviewing contracts, proofreading reports, and collaborating on documents."
              },
              {
                title: "Can I annotate PDF files offline?",
                description:
                  "Yes, if the PDF annotator supports offline processing. A browser-based tool that works locally can let you annotate documents on your device after the website and required resources have loaded."
              },
              {
                title: "Does ShivaPDF annotate PDFs locally in my browser?",
                description:
                  "Local PDF processing means annotations are applied directly in your browser instead of uploading the document to a remote server. Check that the PDF Annotator tool on ShivaPDF.com supports local processing before using it for confidential files."
              },
              {
                title: "Can I annotate a PDF without uploading it?",
                description:
                  "Yes, if the PDF annotator processes files entirely locally in your browser. Your document can then remain on your device rather than being sent to a server. Verify that local processing is supported before annotating sensitive documents."
              },
              {
                title: "Is it safe to annotate PDF files online?",
                description:
                  "Choose a trusted PDF annotation tool and review its privacy practices. For confidential documents, consider a tool that processes files locally without uploading them to a remote server."
              },
              {
                title: "Can I highlight text in a PDF?",
                description:
                  "A PDF annotator with highlighting tools lets you emphasize important passages, definitions, and key information. Highlighting is useful for studying, reviewing documents, and identifying important sections."
              },
              {
                title: "Can I add notes and comments to a PDF?",
                description:
                  "If text annotation or comment tools are available, you can add notes and comments to explain ideas, provide feedback, or mark sections that need attention. This is useful for document reviews and study materials."
              },
              {
                title: "Can I draw on a PDF?",
                description:
                  "A PDF annotator with drawing tools lets you mark up pages using freehand strokes, lines, or other shapes. Drawing can help you emphasize content, sketch ideas, and provide visual feedback."
              },
              {
                title: "Can I add text to a PDF without editing the original text?",
                description:
                  "Text annotation tools can place additional text over a PDF page without necessarily changing the document's original text. This is useful for adding comments, labels, explanations, or reminders."
              },
              {
                title: "Can I underline or strike through PDF text?",
                description:
                  "Some PDF annotation tools provide underline and strikethrough options for marking important or incorrect text. Availability may depend on whether the tool supports text-specific annotations or only drawing-based markup."
              },
              {
                title: "Can I change the color and size of PDF annotations?",
                description:
                  "Depending on the available tools, you may be able to customize annotation colors, line thickness, text size, or highlighting styles. Check the formatting options to create clear and readable markings."
              },
              {
                title: "Can I annotate a scanned PDF?",
                description:
                  "Yes, scanned documents saved as PDFs can generally be annotated using drawing or text overlay tools. Selecting or highlighting the scanned text itself may require OCR support if the document does not contain selectable text."
              },
              {
                title: "Will annotating a PDF change its original content?",
                description:
                  "Annotations add markings, notes, or other elements to a document. Whether these remain separate from the original content depends on the tool and annotation format. Keep an original copy if you need an unchanged version."
              },
              {
                title: "Can I save and share an annotated PDF?",
                description:
                  "If the tool supports exporting or downloading, you can save your annotated document as a PDF and share it with others. Review the exported file to confirm that your annotations are visible and preserved."
              },
              {
                title: "Can I remove or undo PDF annotations?",
                description:
                  "Many annotation tools provide undo, erase, or delete options for removing markings before saving. The ability to edit annotations later depends on how they are stored in the exported PDF."
              },
              {
                title: "Can I annotate a PDF on my mobile phone?",
                description:
                  "You can annotate PDFs on an Android phone, iPhone, or tablet using a compatible browser-based tool. The available annotation controls and performance may vary by device and browser."
              },
              {
                title: "Can I annotate PDFs on Windows and Mac?",
                description:
                  "Yes, a browser-compatible PDF annotator can work on Windows and macOS. If local processing is supported, you can annotate documents directly in the browser without installing a separate desktop application."
              },
              {
                title: "Do I need to install software to annotate a PDF?",
                description:
                  "A browser-based PDF annotator lets you work with documents without installing a separate application. Depending on the tool's offline capabilities, an internet connection may still be required to load the website."
              },
              {
                title: "Can I annotate a password-protected PDF?",
                description:
                  "A password-protected PDF may require its password before it can be opened or modified. Support depends on the document's security settings and the capabilities of the annotation tool."
              },
              {
                title: "Will PDF annotations reduce image or text quality?",
                description:
                  "Adding annotations should generally preserve the original content when the tool does not rasterize or recompress the document. Results depend on the annotation and export method, so check the saved PDF before sharing it."
              },
              {
                title: "Why are my PDF annotations not showing after downloading?",
                description:
                  "Annotations may not appear if the changes were not saved or exported correctly. Try downloading the PDF again, open it in a compatible PDF reader, and check whether the tool requires a separate save or apply step."
              },
              {
                title: "Why is my PDF annotator running slowly?",
                description:
                  "Large PDFs, image-heavy pages, and documents with many annotations can take longer to process. Try closing unnecessary browser tabs, using a supported browser, or working with a smaller document."
              },
              {
                title: "Is the PDF Annotator on ShivaPDF free to use?",
                description:
                  "Visit the PDF Annotator page on ShivaPDF.com to check current availability, supported features, and any file-size or usage limits. These details depend on the tool's current implementation."
              }
            ]} />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default PDFAnnotatorMain;
